export default "__VITE_ASSET__CQFS_8NM__"